import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { Router } from '@angular/router';
import { CURRENCY_LABEL, DEFAULT_PRECISION } from '@app/_helpers/constants';
import { NotificationsService } from '../../../profile/providers/notifications/notifications.service';
import { MbPlansService } from '../../providers/mb-plans.service';

@Component({
  selector: 'app-subscription-activated',
  templateUrl: './subscription-activated.component.html',
  styleUrls: ['./subscription-activated.component.scss']
})
export class SubscriptionActivatedComponent implements OnInit {

  planName: string;
  isSuccess: boolean = false;
  notificationId?: string;
  transaction?: any;

  CURRENCY_LABEL = CURRENCY_LABEL;
  DEFAULT_PRECISION = DEFAULT_PRECISION;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: {
      isSuccess: boolean;
      planName: string;
      notificationId?: string;
      transaction?: any;
    },
    private dialogRef: MatDialogRef<SubscriptionActivatedComponent>,
    private notificationService: NotificationsService,
    private mbPlansService: MbPlansService,
    private router: Router
  ) { }

  async ngOnInit(): Promise<void> {
    this.isSuccess = this.data.isSuccess;
    this.notificationId = this.data.notificationId;
    this.transaction = this.data.transaction;

    if (!this.isSuccess && this.transaction?.planname) {
      this.planName = this.transaction.planname;
    } else if (this.data.planName) {
      this.planName = this.data.planName;
    } else {
      // If plan name is not provided, get the current plan name from the service
      const currentPlan = await this.mbPlansService.getCurrentPlan().toPromise();
      this.planName = currentPlan?.plan?.plan_name ?? 'Your Plan';
    }
  }

  closeDialog() {
    if (this.notificationId) {
      this.notificationService.markPersistantNotificationsAsRead(this.notificationId).subscribe(() => {
        this.dialogRef.close();
      });
    } else {
      this.dialogRef.close();
    }
  }

  routeToTransaction() {
    this.router.navigate(['/trading/profile/transaction-history']);
    this.closeDialog();
  }

  redirectToPlans() {
    this.router.navigateByUrl('/trading/profile/user/plans');
    this.closeDialog();
  }
}
